import * as Yup from 'yup';

export default Yup.object().shape({
  name: Yup.string().required('Debe ingresar un nombre'),
  price: Yup.number(),
  priority: Yup.number()
});
